const paymentMethods = {};

export const registerPaymentMethod = (paymentMethod) => {
    paymentMethods[paymentMethod.gateway_id] = paymentMethod;
}

export const getPaymentMethods = () => paymentMethods;

export const getPaymentMethod = (id) => paymentMethods[id] ? paymentMethods[id] : null;